import { useEffect, useState, useRef } from "react";

export const useAxisMeasure = (defaultAxisLabelWidth: number) => {
  const [xWidth, setXWidth] = useState(defaultAxisLabelWidth);
  const [yWidth, setYWidth] = useState(defaultAxisLabelWidth);
  
  const horizontalRefs = useRef<(HTMLDivElement | null)[]>([]);
  const verticalRefs = useRef<(HTMLDivElement | null)[]>([]);

  // Functions to set refs
  const setHorizontalRef = (index: number, el: HTMLDivElement | null) => {
    // console.log({horEL: el})
    horizontalRefs.current[index] = el;
  };

  const setVerticalRef = (index: number, el: HTMLDivElement | null) => {
    // console.log({verEL: el})
    verticalRefs.current[index] = el;
  };

  // console.log({horizontalRefs, verticalRefs})

  useEffect(() => {
    // Measure horizontal labels
    let maxHorizontalWidth = 0;
    horizontalRefs.current.forEach(ref => {
      if (ref) {
        const width = ref.offsetWidth;
        maxHorizontalWidth = Math.max(maxHorizontalWidth, width);
      }
    });

    // Measure vertical labels  
    let maxVerticalWidth = 0;
    verticalRefs.current.forEach(ref => {
      if (ref) {
        const width = ref.offsetWidth;
        maxVerticalWidth = Math.max(maxVerticalWidth, width);
      }
    });

    // Update state - use measured width if less than config, but cap at config maximum
    if (maxHorizontalWidth > 0) {
      const targetWidth = Math.min(maxHorizontalWidth + 10, defaultAxisLabelWidth); // +10 for padding, cap at max
      setXWidth(targetWidth);
    }

    if (maxVerticalWidth > 0) {
      const targetWidth = Math.min(maxVerticalWidth + 10, defaultAxisLabelWidth); // +10 for padding, cap at max
      setYWidth(targetWidth);
    }
  },[]);

  return {
    xWidth,
    yWidth,
    setHorizontalRef,
    setVerticalRef
  };
};